import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;

  ${theme.breakpoints.only("tablet")} {
    flex-flow: column nowrap;
  }
`;

export const TextColumn = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 8px;
`;

export const Section = styled.div`
  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    font-family: ${fontRobotoCondensed};
    text-transform: uppercase;
  }
`;

export const StyledHeadlineEntityLink = styled(EntityLink)`
  color: #000000;
`;

export const Headline = styled.div`
  font-weight: 600;
  font-size: 15px;
  font-family: ${fontMerriweather};
  line-height: 140%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
  }
`;

export const ActionBar = styled.div`
  time {
    color: #727272;
    font-size: 11px;
  }
`;

export const StyledCoverEntityLink = styled(EntityLink)`
  display: block;

  inline-size: 100px;
`;

export const CoverImage = styled.div`
  inline-size: 100px;
  block-size: 100px;
`;
